"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Representation of optimization data returned from optimization engine for one category and price zone.
 *
 * @author Jaroslav Sevcik
 */


var OptimizationScenarioData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(OptimizationScenarioData, _DomainObject_1$Domai);

  /**
   * @param points List of all points to draw an optimization graph based on average margin in %.
   *        Average margin is the X-axis; profit, revenue, quantity hold absolute values for the Y-axis (3 graphs).
   * @param actualData Current setting of profit, revenue and quantity
   * @param optimalMargins List of optimal margins for individual optimization goals suggested by the optimization engine.
   */
  function OptimizationScenarioData(points, actualData, optimalMargins) {
    var _this;

    _classCallCheck(this, OptimizationScenarioData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimizationScenarioData).call(this));
    _this.points = points;
    _this.actualData = actualData;
    _this.optimalMargins = optimalMargins;
    return _this;
  }

  return OptimizationScenarioData;
}(DomainObject_1.DomainObject);

exports.OptimizationScenarioData = OptimizationScenarioData;